const MINIMUM_LENGTH_FOR_SUGGESTED_TITLE = 10 as const;

export function titleIsConsideredSufficient(title: string): boolean {
  return title.length >= MINIMUM_LENGTH_FOR_SUGGESTED_TITLE;
}
